import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const dataIoKpis /*: WarehouseKPI[] */ = [
  // Data Capture Accuracy
  {
    id: 'data_capture_accuracy',
    processType: ActivityEventProcessType.IDENTIFICATION,
    category: 'data_io',
    title: 'Data Capture Accuracy',
    description:
      'Percentage of barcode/RFID scans that are successful on first attempt',
    unit: '%',
    formula:
      '(COUNT(successful_first_scans) / COUNT(total_scan_attempts)) * 100',
    tags: ['data_quality'],
    benchmark: {
      standards: {
        site: {
          target: 99,
          warning: { lower: 97 },
          critical: { lower: 95 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 95 },
            { label: 'Warning', min: 95.01, max: 97 },
            { label: 'Target', min: 97.01, max: 99 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['scanner_type', 'item_category', 'operator_id'],
    alertTopic: 'warehouse.alerts.data_io.capture_accuracy',
  },
  // ... (repeat for all data_io KPIs, converting each benchmark) ...
];

export default dataIoKpis;
